<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch sử đối soát phiếu thu chuyển khoản</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary" @click="exportExcel">
          Xuất excel
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="$router.push('/list-receipts')"
        >
          Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <InputRangeRaw
              v-model="createdDateRange"
              placeholder="Thời gian"
              clearable
              :max-date="new Date()"
            ></InputRangeRaw>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
              @keyup.enter="submitForm"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.compareUserId"
              :options="optionsListUser"
              placeholder="Người đối soát"
            >
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              show-empty
              empty-text="Không có dữ liệu!"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>

              <template #cell(compareTime)="data">
                <p>{{ data.item.compareTime | formatDate('DD/MM/YYYY HH:mm:ss') }}</p>
              </template>
              <template #cell(amount)="data">
                <p>{{ data.item.amount | transformMoney }}</p>
              </template>
              <template #cell(receiptCode)="data">
                <p @click="detailReceipt(data.item.receiptId)" class="text-primary cursor">
                  {{ data.item.receiptCode }}
                </p>
              </template>
              <template #cell(merchantId)="data">
                <p><b>Tên:</b> {{ data.item.merchantName }}</p>
                <p><b>Email:</b> {{ data.item.merchantEmail }}</p>
                <p><b>Địa chỉ:</b> {{ data.item.merchantAddress }}</p>
              </template>
              <template #cell(compareUserName)="data">
                <p><b>Tên:</b> {{ data.item.compareUserName }}</p>
                <p><b>Email:</b> {{ data.item.compareUserEmail }}</p>
              </template>
              <!-- <template #cell(type)="data">
                <p>{{  Config.getText(data.item.type, Config.createdFileBy) }}</p>
              </template>
              <template #cell(serviceType)="data">
                <p>
                  {{ Config.getText(data.item.serviceType, Config.serviceType) }}
                </p>
              </template> -->
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { ReceiptService } from '@/services/receipts.service'
  import { StaffService } from '@/services/staff.service'

  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import InputRangeRaw from '../../components/InputRangeRaw.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'receiptCode', label: 'Mã phiếu thu' },
    { key: 'merchantId', label: 'Merchant' },
    { key: 'contractCode', label: 'Mã hợp đồng' },
    { key: 'amount', label: 'Số tiền' },
    { key: 'licenseCode', label: 'Mã chứng từ' },
    { key: 'deviceSerial', label: 'Serial thiết bị' },
    { key: 'compareTime', label: 'Thời gian đối soát' },
    { key: 'compareUserName', label: 'Người đối soát' },
  ]

  const rawSearch = {
    compareUserId: null,
    key: null,
    pageIndex: 1,
    pageSize: 20,
  }
  export default {
    components: { InputRangeRaw },

    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        search: cloneDeep(rawSearch),
        pagination: {
          total: 0,
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        createdDateRange: null,
        // option
        optionsListUser: [],
      }
    },
    watch: {
      'search.pageIndex': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      this.getListUser()
    },

    methods: {
      async submitForm() {
        this.search.pageIndex = 1
        this.fetchData()
      },
      detailReceipt(id) {
        if (!id) {
          this.showFailMx('Không tìm thấy receiptId')
          return
        }
        window.open(`/detail-receipts/${id}`)
      },
      removeForm() {
        this.search = cloneDeep(rawSearch)
        this.createdDateRange = null
        this.fetchData()
      },
      // Lấy danh sách nhân viên
      async getListUser() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.optionsListUser = data.data.map(e => {
              return { id: e.userId, text: e.name }
            })
            this.optionsListUser.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.getParams()
          // {
          //   "compareUserId": "string",
          //   "from": 0,
          //   "key": "string",
          //   "pageIndex": 0,
          //   "pageSize": 0,
          //   "to": 0
          // }
          // console.log(123, params)
          // return
          const response = await ReceiptService.getReceiptCompareHistory(params)
          if (response.code === 1000) {
            console.log(response)
            this.lists = response.totalPage.total > 0 ? response.data : []
            this.pagination.total = response.totalPage.total
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
      getParams() {
        this.search.from = null
        this.search.to = null
        if (this.createdDateRange?.start && this.createdDateRange?.end) {
          this.search.from = moment(this.createdDateRange.start).startOf('day').valueOf()
          this.search.to = moment(this.createdDateRange.end).endOf('day').valueOf()
        }
        const params = {
          ...rawSearch,
          ...this.search,
        }
        // remove data null and '0'
        for (const key in params) {
          if (
            params[key] === null ||
            params[key] === '0' ||
            (Array.isArray(params[key]) && params[key].length === 0)
          ) {
            delete params[key]
            delete this.search[key]
          }
        }
        return params
      },
      async exportExcel() {
        try {
          const params = this.getParams()
          if (!params.to || !params.from) {
            this.showFailMx('Vui chọn thời gian muốn xuất file (tối đa 3 tháng)')
            return
          }
          const fromDate = moment(params.from)
          const toDate = moment(params.to)
          const diff = toDate.diff(fromDate, 'day')
          if (diff >= 92) {
            this.showFailMx('Thời gian xuất file không quá 3 tháng')
            return
          }
          params.pageIndex = 1
          params.pageSize = 100000
          this.showLoading = true
          await ReceiptService.exportReceiptCompareHistory(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
